import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export type SortDirection = 'asc' | 'desc';

export function SortIcon<T extends string>({
  field,
  activeField,
  direction,
}: {
  field: T;
  activeField: T;
  direction: SortDirection;
}) {
  if (activeField !== field) return <ArrowUpDown className="ml-1 h-3 w-3 text-muted-foreground/50" />;
  if (direction === 'asc') return <ArrowUp className="ml-1 h-3 w-3" />;
  return <ArrowDown className="ml-1 h-3 w-3" />;
}
